import wx from 'weixin-js-sdk'
// 时间转换的方法
export const getDateTimeToString = () => {
  const date_ = new Date()
  const year = date_.getFullYear()
  let month = date_.getMonth() + 1
  let day = date_.getDate()
  if (month < 10) month = '0' + month
  if (day < 10) day = '0' + day
  let hours = date_.getHours()
  let mins = date_.getMinutes()
  let secs = date_.getSeconds()
  const msecs = date_.getMilliseconds()
  if (hours < 10) hours = '0' + hours
  if (mins < 10) mins = '0' + mins
  if (secs < 10) secs = '0' + secs
  if (msecs < 10) secs = '0' + msecs
  return year + '' + month + '' + day + '' + hours + '' + mins + '' + secs
}

/**
 * 动态修改标题
 * @param {title} 标题名
 */
export const changeTitleClick = (title) => {
  document.setTitle = function (t) {
    document.title = t
    const i = document.createElement('iframe')
    i.src = './favicon.ico'
    i.style.display = 'none'
    i.onload = function () {
      setTimeout(function () {
        i.remove()
      }, 9)
    }
    document.body.appendChild(i)
  }
  setTimeout(function () {
    document.setTitle(title)
  }, 1)
}

/**
 * 获取url参数
 * @returns
 */
export const getUrlParams = () => {
  const geturl = decodeURIComponent(window.location.href)
  console.log(geturl)
  const seturl = geturl.split('#')[0]
  const getqyinfo = seturl.split('?')[1]
  const getqys = getqyinfo.split('&')
  const obj = {} // 创建空对象，接收截取的参数
  for (let i = 0; i < getqys.length; i++) {
    const item = getqys[i].split('=')
    const key = item[0]
    const value = item[1]
    obj[key] = value
  }
  return obj
}
// 格式化时间插件
export const datePipe = (timestamp, format = 'yyyy-MM-dd hh:mm:ss') => {
  const date = new Date(timestamp)
  const o = {
    'y+': date.getFullYear(),
    'M+': date.getMonth() + 1, // 月份 "d+": value.getDate(), // 日
    'd+': date.getDate(),
    'h+': date.getHours(), // 小时 "m+": value.getMinutes(), // 分 "s+": value.getSeconds(), // 秒
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return format
}

/**
 * 微信分享
 * 获取微信加签信息
 * @param {data}: 获取的微信加签
 * @param {shareData}: 分享配置参数
 */
export const wexinShare = (data, shareData) => {
  // var wx = require('weixin-js-sdk') || window['wx'];
  const appId = data.appId
  const timestamp = data.timestamp
  const nonceStr = data.nonceStr
  const signature = data.signature
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。（测试记得关掉）
    appId: appId, // 必填，公众号的唯一标识
    timestamp: timestamp, // 必填，生成签名的时间戳
    nonceStr: nonceStr, // 必填，生成签名的随机串
    signature: signature, // 必填，签名，见附录1
    jsApiList: [
      'updateAppMessageShareData',
      'updateTimelineShareData',
      'onMenuShareTimeline',
      'onMenuShareAppMessage'
    ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    openTagList: ['wx-open-launch-app']
  })
  wx.checkJsApi({
    jsApiList: [
      'chooseImage',
      'updateAppMessageShareData',
      'onMenuShareTimeline',
      'onMenuShareAppMessage'
    ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
    success: function (res) {
      // 以键值对的形式返回，可用的api值true，不可用为false
      // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
      console.log(res, 'checkJsApi')
    }
  })
  wx.ready(function () {
    console.log('执行ready')
    // //分享到朋友圈”及“分享到QQ空间”
    wx.updateTimelineShareData({
      title: shareData.title, // 分享标题
      link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareData.imgUrl, // 分享图标
      success: function (res) {
        // 设置成功
        console.log('分享朋友圈成功返回的信息为:', res)
      }
    })

    // “分享给朋友”及“分享到QQ”
    wx.updateAppMessageShareData({
      title: shareData.title, // 分享标题
      desc: shareData.desc, // 分享描述
      link: shareData.link, // 分享链接 该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareData.imgUrl, // 分享图标
      success: function (res) {
        console.log('分享朋友成功返回的信息为:', res)
      }
    })
    wx.onMenuShareAppMessage({
      title: shareData.title, // 分享标题
      desc: shareData.desc, // 分享描述
      link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
      imgUrl: shareData.imgUrl, // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果 type 是music或video，则要提供数据链接，默认为空
      success: function (res) {
        console.log('分享朋友成功返回的信息为:', res)
      }
    })
    wx.onMenuShareTimeline({
      title: shareData.title, // 分享标题
      link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareData.imgUrl, // 分享图标
      success: function () {
        // 用户点击了分享后执行的回调函数
      }
    })
  })
  wx.error(function (res) {
    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    console.log('验证失败返回的信息:', res)
  })
}
/**
 * 点击复制文本函数
 */
export const copy = (data) => {
  const url = data
  // 新建一个文本框
  const oInput = document.createElement('input')
  // 赋值给文本框
  oInput.value = url
  document.body.appendChild(oInput)
  // 选择对象;
  oInput.select()
  // 执行浏览器复制命令
  document.execCommand('Copy')
  // 复制完成删除掉输入框
  oInput.remove()
  this.$toast('复制成功')
  console.log('复制成功')
}
